
import request from '@/utils/request'

// 分页查询广告
export function fetchList (data) {
  return request.post('/system/ad/getAllAd',data)
}
// 获取能操作广告管理的车场集合
export function getAuthCom (data) {
    return request.get('/system/ad/getAuthCom',data)
  }
// 预览图片和视频
export function preview (adPath) {
  return request.get('/system/ad/preview?adPath=' + adPath)
}
// 审核不通过
export function checkNotPass (data) {
  return request.post(`/system/ad/checkNotPass?adId=${data.adId}&comId=${data.comId}`,data)
}
// 审核通过
export function checkPass (data) {
return request.post(`/system/ad/checkPass?adId=${data.adId}&comId=${data.comId}` ,data)
}